<template >
  <b-container fluid style="padding:0px;" class="mb-4">
    <b-row class="mt-4 mb-4" align-h="center" align="center" v-if="codeClient.includes('chinango')">
      <b-col><b-button variant="warning" size="lg" pill @click="showActualizacionDatos=true">Actualización 2026</b-button></b-col>
    </b-row>
    <b-row no-gutters >
      <b-col>
        <b-button block v-b-toggle="'collapse-contribuyente'" variant="info" style="text-align:left;"><b-icon icon="person-fill"/> Datos del Contribuyente</b-button>
        <b-collapse id="collapse-contribuyente" style="width: 100%;" accordion="Padrones" role="tabpanel">
          <b-card>
            <formContribuyente :contribuyenteActual="contribuyenteActual" :isAgregarContrib="false" :tipoPadron="tipoPadron"/>
            <b-row align-h="center">
              <!----------------- GUADAR CAMBIOS--------------------->
              <b-col cols="12" lg="4" class="mt-5">
                <b-dropdown split variant="danger" @click="guardarCambiosContrib()">
                  <template #button-content>
                    <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                    <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
                    <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
                  </template>
                  

                  <b-dropdown-form>
                    <b-form-group >
                        <b-form-textarea
                          v-model="contribuyenteActual.fundamento"
                          placeholder="Fundamento ..."
                          rows="3"
                          max-rows="3"
                        ></b-form-textarea>
                    </b-form-group>
                  </b-dropdown-form>
                </b-dropdown>
              </b-col>
              <!-----------------ELIMINAR CONTRIBUYENTE---------------------------->
              <b-col cols="12" lg="4" class="mt-5">
                <b-dropdown split variant="secondary" @click="isShowModalEliminaContrib=true">
                  <template #button-content>
                    <b-spinner v-if="isEliminandoContrib"></b-spinner>
                    <strong v-if="isEliminandoContrib"> Eliminando . . .</strong>
                    <strong v-if="!isEliminandoContrib">Eliminar Contribuyente <b-icon   icon="trash"/></strong>
                  </template>                  

                  <b-dropdown-form>
                    <b-form-group >
                        <b-form-textarea
                          v-model="contribuyenteActual.fundamento"
                          placeholder="Fundamento ..."
                          rows="3"
                          max-rows="3"
                        ></b-form-textarea>
                    </b-form-group>
                  </b-dropdown-form>
                </b-dropdown>
              </b-col>

            </b-row>      
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>

    <!-- -------------------- UBICACION ----------------------  -->

    <b-row ><!--v-if="contribuyenteActual.coordenadas != null"-->
      <b-col class="mt-1">
        <b-button block v-b-toggle="'collapse-ubicacion'" variant="info" style="text-align:left;" ><b-icon icon="geo-alt-fill"/> Ubicación del Inmueble</b-button><!--@click="consultarUbicacionContrib"-->
        <b-collapse id="collapse-ubicacion" style="width: 100%;" accordion="Padrones" role="tabpanel">
          <b-row class="mt-2">
            <b-col cols="12" lg="12" >
              <b-input-group >
                <b-input-group-prepend is-text><b-icon icon="geo-alt-fill" @click="isShowEditUbicacionDir=true" style="cursor:pointer;"></b-icon></b-input-group-prepend>
                <b-form-input placeholder="Ubicación:" type="text" :state="$v.contribuyenteActual.ubicacion.descripcion.$invalid?false:null" v-model="contribuyenteActual.ubicacion.descripcion"></b-form-input> 
                <p class="error" v-if="!$v.contribuyenteActual.ubicacion.descripcion.minLength">La Ubicación no puede estar vacio</p>
                <p class="error" v-if="!$v.contribuyenteActual.ubicacion.descripcion.maxLength">La Ubicación es demasiado largo</p>
                <p class="error" v-if="!$v.contribuyenteActual.ubicacion.descripcion.required">Este campo es obligatorio.</p>
              </b-input-group>
            </b-col>
          </b-row>
          <b-card>
            <div class="mapouter" v-if="contribuyenteActual.coordenada.lat != '0.0'">
              <b-embed type="iframe" aspect="16by9" allowfullscreen :src="srcToEmbed+ubicToEmbedCoor+paramsToEmbed"></b-embed>
            </div>
            <div class="mapouter" v-if="contribuyenteActual.coordenada.lat == '0.0' && contribuyenteActual.coordenada.lng == '0.0'">
              <b-embed type="iframe" aspect="16by9" allowfullscreen :src="srcToEmbed+ubicToEmbedUbic+paramsToEmbed"></b-embed>
            </div>
            <!--<loading :active.sync="isConsultandoUbicacion" :is-full-page="true"></loading>-->
            <b-row><b-col class="mb-2" style="cursor:pointer;"><b-badge variant="success"  @click="verModalUTMToLatLng=true; este=null; norte=null;">Usar UTM</b-badge></b-col></b-row>
            <b-row>
              <b-col cols="12" lg="6">
                <b-form-group label="Latitud:">
                  <b-form-input type="text" v-model="contribuyenteActual.coordenada.lat"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group label="Longitud:">
                  <b-form-input type="text" v-model="contribuyenteActual.coordenada.lng"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>  
            <b-row align-h="center">
              <b-col cols="12" md="5" lg="5" xl="3">
                <b-button block variant="danger" @click="guardarCambiosUbicacionContrib()">
                  <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                  <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
                  <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
                </b-button>
              </b-col>
            </b-row>        
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>


    <!---------------------- BASES FISCALES --------------------->
    <b-row no-gutters>
      <b-col class="mt-1">
        <b-button block v-b-toggle="'collapse-basesFiscales'" variant="info" style="text-align:left;"><b-icon icon="file-spreadsheet-fill"/> Bases Fiscales</b-button>
        <b-collapse id="collapse-basesFiscales" style="width: 100%;" accordion="Padrones" role="tabpanel">
          <b-card>
            <!--if tipoContribuyente == 1(Catastral)-->
            <b-row align="center" v-if="contribuyenteActual.tipoContribuyente == '1'" >
              <b-col cols="12"><h5><b-icon icon="cash-stack"/> Valuaciones Catastrales</h5></b-col>
            </b-row>
            <b-table style=" font-size:14px;" v-if="contribuyenteActual.tipoContribuyente == '1'" responsive="xl" striped small sticky-header :items="contribuyenteActual.basesFiscales" :fields="fieldsTableBasesFiscales">
              <template v-slot:cell(valuacion)="row">
                <span @click="showModalEditarTipoValuacion(row.index)" style="cursor:pointer;">{{row.item.valuacion==null||row.item.valuacion==''?'--':row.item.valuacion}}</span>
              </template>
              <template v-slot:cell(acciones)="row">    
                <b-icon @click="showModalEditarBases(row.index)" style="cursor:pointer;"  icon="pencil-square"/>
              </template>
            </b-table>
            <b-row align-h="end" align="end" v-if="contribuyenteActual.tipoContribuyente == '1'">
              <!-- <b-col cols="11" md="8" lg="3" xl="2" class="mb-5">
                <b-button size="sm" block variant="secondary" @click="isShowCartografia=true">Cartografía <b-icon icon="map-fill"/></b-button>
              </b-col> -->
              <b-col cols="11" md="8" lg="3" xl="2" class="mb-5">
                <b-button size="sm" block variant="secondary" @click="showAgregarManifestacion()">Agregar Avalúo <b-icon icon="plus-circle-fill"/></b-button>
              </b-col>
              <b-col cols="11" md="8" lg="2" xl="2" class="mb-5">
                <b-button size="sm" block variant="warning" @click="isShowFusionarPredio=true">Fusionar Predio <b-icon icon="grid1x2-fill"/></b-button>
              </b-col>
              <b-col cols="11" md="8" lg="2" xl="2" class="mb-5">
                <b-button size="sm" block variant="warning" @click="isShowSubdividirPredio=true">Dividir Predio <b-icon icon="grid1x2-fill"/></b-button>
              </b-col>
            </b-row>
            
            <!--<b-button v-if="contribuyenteActual.tipoContribuyente == '1'" variant="success" size="sm">Agregar Base</b-button>-->
            <!--if tipoContribuyente == 3(Agua Potable)-->
            <panel-agua v-if="contribuyenteActual.tipoContribuyente == '3'" :guardarCambiosContrib="guardarCambiosBasesContrib" :isGuardandoDatosContrib="isGuardandoDatosContrib" :contribuyenteActual="contribuyenteActual"/>

            <!--if tipoContribuyente != 1 & !=3-->
            <b-form-group v-if="contribuyenteActual.tipoContribuyente != '1' && contribuyenteActual.tipoContribuyente != '3'" label="Tipo:">
              <b-form-select v-model="contribuyenteActual.basesFiscales[0].tipo" :options="optionsTipoLicencia"></b-form-select>
            </b-form-group>
            <b-row>
              <b-col cols="12" lg="6">
                <b-form-group v-if="contribuyenteActual.tipoContribuyente != '1' && contribuyenteActual.tipoContribuyente != '3'&& contribuyenteActual.tipoContribuyente != null" label="Fecha Inicial:">
                  <b-form-input type="date" v-model="contribuyenteActual.basesFiscales[0].fechaInicio"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group v-if="contribuyenteActual.tipoContribuyente == '4' || contribuyenteActual.tipoContribuyente == '5' || contribuyenteActual.tipoContribuyente == '6' || contribuyenteActual.tipoContribuyente == '7'" label="Dimensión:">
                  <b-form-input type="number" v-model="contribuyenteActual.basesFiscales[0].dimension"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="12" v-if="contribuyenteActual.tipoContribuyente != '1' && contribuyenteActual.tipoContribuyente != '3'">
                <b-row class="mt-3">
                  <b-col>
                      <b-form-checkbox v-model="verInfoAdicionalLicencia">Ver Información Adicional</b-form-checkbox>
                  </b-col>                  
                </b-row>
                <b-row v-if="verInfoAdicionalLicencia">
                  <b-col cols="12">
                    <label>Giro</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].giro" ></b-form-input>
                  </b-col>
                  <b-col cols="12" lg="8">
                    <label>Nombre Comercial</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].nombreComercial" ></b-form-input>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <label>Horario</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].horario" ></b-form-input>
                  </b-col>
                   <b-col cols="12" lg="4">
                    <label>Capital de inversión</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].capital" ></b-form-input>
                  </b-col>
                   <b-col cols="12" lg="4">
                    <label>Superficie Terreno</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].superficieT" ></b-form-input>
                  </b-col>
                   <b-col cols="12" lg="4">
                    <label>Superficie Construcción</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].superficieC" ></b-form-input>
                  </b-col>
                   <b-col cols="12" lg="6">
                    <label>Clasificación</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].clasificacionc" ></b-form-input>
                  </b-col>
                   <b-col cols="12" lg="6">
                    <label>Clave Catastral</label>
                    <b-form-input type="text" v-model="contribuyenteActual.basesFiscales[0].claveCatastral" ></b-form-input>
                  </b-col>
                  <b-col>
                  </b-col>
                </b-row>
                <b-row>
                  
                    <b-col cols="12" lg="6">
                      <b-form-group v-if="contribuyenteActual.tipoContribuyente == '2' " label="Dimensión Anuncio m2:">
                        <b-form-input type="number" v-model="contribuyenteActual.basesFiscales[0].dimension"></b-form-input>
                      </b-form-group>   
                      <b-form-group v-if="contribuyenteActual.tipoContribuyente == '2'" label="Tipo Anuncio:">
                        <b-form-select v-model="contribuyenteActual.basesFiscales[0].tipoAdicional" :options="this.catalogoPadrones.tiposLicenciaAnuncios"></b-form-select>
                      </b-form-group>                  
                    </b-col>
                </b-row>
              </b-col>

            </b-row>
            <b-row v-if="contribuyenteActual.tipoContribuyente != '1' && contribuyenteActual.tipoContribuyente != '3'" align-h="between" align="between" class="mt-5">
              <b-col cols="12" lg="4">
                <b-button block variant="danger" @click="guardarCambiosBasesContrib(null)">
                  <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                  <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
                  <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
                </b-button>
              </b-col>

              <b-col cols="11" sm="6"   >
                <b-dropdown split variant="secondary" >
                  <template #button-content>
                    <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                    <strong v-if="isGuardandoDatosContrib"> Generando . . .</strong>
                    <strong v-if="!isGuardandoDatosContrib"> Generar Documento <b-icon  shift-v="-1" font-scale="1.3" icon="file-earmark-text-fill"/></strong>
                  </template>
                  <b-dropdown-form v-if="contribuyenteActual!=null">
                    <b-form-group >
                        <b-form-input
                          v-model="folioDoc1"
                          placeholder="Folio Documento"
                        ></b-form-input>
                        <b-form-input
                          v-model="folioDoc2"
                          placeholder="Folio Pago"
                        ></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-item @click="generarDocumento(contribuyenteActual.tipoContribuyente, 'Licencia')"><b-icon icon="arrow-right-circle-fill"/> Licencia/Permiso </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>

          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
    <!---------------- ADEUDOS -------------------->
    <b-row>
      <b-col class="mt-1">
        <b-button block variant="info" style="text-align:left;" @click=" isVisibleCollapseAdeudo = !isVisibleCollapseAdeudo"><b-icon icon="list-stars"/> Adeudos Fiscales</b-button>
        <b-collapse style="width: 100%;" v-model="isVisibleCollapseAdeudo" accordion="Padrones" role="tabpanel">
          <b-row>
            <b-col class="mt-5 mb-5">
              <b-dropdown split variant="danger" >
                  <template #button-content>
                    <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                    <strong v-if="isGuardandoDatosContrib"> Generando . . .</strong>
                    <strong v-if="!isGuardandoDatosContrib"> Generar Notificación <b-icon  shift-v="-1" font-scale="1.3" icon="file-earmark-text-fill"/></strong>
                  </template>
                  

                  <b-dropdown-form v-if="contribuyenteActual!=null">
                    <b-form-group >
                        
                        
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-item v-if="contribuyenteActual.tipoContribuyente == '1'" @click="generarDocumento(1, 'Requerimiento de pago')"><b-icon icon="arrow-right-circle-fill"/> Requerimiento de pago</b-dropdown-item>
                  
                </b-dropdown>
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <!-- ------------- PAGOS --------------------- -->
    <b-row>
      <b-col class="mt-1">
        <b-button block variant="info" style="text-align:left;" @click="consultarPagosContrib(); isVisibleCollapsePagos = !isVisibleCollapsePagos"><b-icon icon="cash-stack"/> Histórico de Pagos</b-button>
        <b-collapse style="width: 100%;" v-model="isVisibleCollapsePagos" accordion="Padrones" role="tabpanel">
          <b-row>

            <b-col cols="12" class="mt-2 mb-2"  v-if="contribuyenteActual.basesFiscales[0].servicioAgua!=null && contribuyenteActual.basesFiscales[0].servicioAgua.tieneAutogestionIusa"><b-badge @click="actualizaPagosContrib" variant="success" style="cursor:pointer;"> Integrar Pagos IUSA <b-icon icon="arrow-repeat"/> </b-badge></b-col>
            <b-col cols="12">
                <b-card>
                  <loading :active.sync="isConsultandoPago" :is-full-page="true"></loading>
                  <b-row v-if="isShowTablePagos" align="right">
                    
                    <b-col cols="12" v-if="contribuyenteActual.pagos!=null && contribuyenteActual.pagos.length > 0">
                      <b-form-checkbox switch v-model="isShowDetallePago">Mostrar Detalle</b-form-checkbox> 
                    </b-col>
                    <b-col cols="12">
                      <div class="error" v-if="contribuyenteActual.pagos==null || contribuyenteActual.pagos.length == 0">Sin pagos registrados.</div>
                      <b-row v-for="(contrib, idx) in contribuyenteActual.pagos" :key="idx" class="mt-2 mb-2">
                        <b-col cols="12">
                        <b-input-group size="sm">
                          <b-input-group-prepend is-text><b-icon icon="person-fill"></b-icon></b-input-group-prepend>
                          <b-form-input size="sm" disabled v-model="contrib.contribuyente"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col>
                          <b-tabs justified active-nav-item-class="font-weight-bold  text-success">
                            <b-tab title="Pagos">
                              <!-- Pagos -->
                              <b-table responsive striped small sticky-header :items="isShowDetallePago?contrib.pagos:contrib.pagosResumen" :fields="fieldsTablePagos">
                                <template v-slot:cell(folio)="row" >
                                  <b-button v-if="row.item.sistema=='S'" @click="consultaRecibo(row.item.folio)"  size="sm" variant="link">{{row.item.folio}}</b-button> 
                                  <label v-if="row.item.sistema!='S'">{{row.item.folio}}</label>
                                </template>

                                <template #cell(show_details)="row">
                                  <b-button size="sm" variant="success" @click="row.toggleDetails" class="mr-2">
                                    <b-icon icon="plus"/>
                                  </b-button>
                                </template>

                                <template #row-details="row">
                                  <b-card>
                                    <b-row class="mb-2">
                                      <b-col cols="12">
                                        <pre >{{row.item.extras}}</pre>
                                      </b-col>
                                    </b-row>
                                    <b-button size="sm" variant="success" @click="row.toggleDetails">Cerrar</b-button>
                                  </b-card>
                                </template>
                              </b-table>
                            </b-tab>
                            <!-- Exentos -->
                            <b-tab title="Exentos" >
                              <b-table responsive striped small sticky-header :items="contrib.exentos" :fields="fieldsExento">
                                <template v-slot:cell(id)="row" >
                                  <b-icon style="cursor:pointer;" icon="trash" @click="cancelaExento(row.item.id)"/>
                                </template>
                                <template #cell(show_details)="row">
                                  <b-button size="sm" variant="success" @click="row.toggleDetails" class="mr-2">
                                    <b-icon icon="plus"/>
                                  </b-button>
                                </template>

                                <template #row-details="row">
                                  <b-card>
                                    <b-row class="mb-2">
                                      <b-col cols="12">
                                        <pre >{{row.item.extras}}</pre>
                                      </b-col>
                                    </b-row>
                                    <b-button size="sm" variant="success" @click="row.toggleDetails">Cerrar</b-button>
                                  </b-card>
                                </template>

                              </b-table>
                            </b-tab>
                            <!-- Creditos -->
                            <b-tab title="Créditos"  v-if="contrib.creditos!=null && contrib.creditos.length>0">
                              <b-table responsive striped small sticky-header :items="contrib.creditos" :fields="fieldsCredito">
                                <template v-slot:cell(folio)="row" >
                                  <b-button v-if="row.item.sistema=='S'" @click="consultaRecibo(row.item.folio)"  size="sm" variant="link">{{row.item.folio}}</b-button> 
                                  <label v-if="row.item.sistema!='S'">{{row.item.folio}}</label>
                                </template>

                                <template #cell(show_details)="row">
                                  <b-button size="sm" variant="success" @click="row.toggleDetails" class="mr-2">
                                    <b-icon icon="plus"/>
                                  </b-button>
                                </template>

                                <template #row-details="row">
                                  <b-card>
                                    <b-row class="mb-2">
                                      <b-col cols="12">
                                        <pre >{{row.item.extras}}</pre>
                                      </b-col>
                                    </b-row>
                                    <b-button size="sm" variant="success" @click="row.toggleDetails">Cerrar</b-button>
                                  </b-card>
                                </template>
                              </b-table>
                            </b-tab>

                            
                          </b-tabs>

                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                 
                </b-card>
            </b-col>
              
          </b-row>
          <b-row align="end">
            <b-col cols="11" sm="12"  class="mt-2 mb-4 " >

                <b-dropdown split variant="warning" >
                  <template #button-content>
                    <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
                    <strong v-if="isGuardandoDatosContrib"> Generando . . .</strong>
                    <strong v-if="!isGuardandoDatosContrib"> Generar Certificado de Pago <b-icon  shift-v="-1" font-scale="1.3" icon="file-earmark-text-fill"/></strong>
                  </template>
                  

                  <b-dropdown-form v-if="contribuyenteActual!=null">
                    <b-form-group >
                        <b-form-input
                          v-model="folioDoc1"
                          placeholder="Folio Documento"
                        ></b-form-input>
                        <b-form-input
                          v-model="folioDoc2"
                          placeholder="Folio Pago"
                        ></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-item v-if="contribuyenteActual.tipoContribuyente == '1'" @click="generarDocumento(1, 'Certificado de no adeudo predial')"><b-icon icon="arrow-right-circle-fill"/> Certificado No Adeudo Predial</b-dropdown-item>
                  <b-dropdown-item v-if="contribuyenteActual.tipoContribuyente == '1'" @click="generarDocumento(1, 'Certificado de no adeudo aportacion a mejoras')"><b-icon icon="arrow-right-circle-fill"/> Certificado No Adeudo Aportaciones</b-dropdown-item>
                  <b-dropdown-item v-if="contribuyenteActual.tipoContribuyente == '3'" @click="generarDocumento(3, 'Certificado de no adeudo agua')"><b-icon icon="arrow-right-circle-fill"/> Certificado de No Adeudo</b-dropdown-item>
                </b-dropdown>

              </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <!-- ------------- CONVENIOS Y FORMATOS --------------------- -->
    <b-row>
      <b-col class="mt-1">
        <b-button block variant="info" style="text-align:left;" @click="consultarPagosContrib(); isVisibleCollapseFormatos = !isVisibleCollapseFormatos"><b-icon icon="files"/> Histórico de Liquidaciones </b-button>
        <b-collapse style="width: 100%;" v-model="isVisibleCollapseFormatos" accordion="Padrones" role="tabpanel">
          <b-row>

            <b-col >
              <!-- Ordenes Pago -->
                <b-table responsive striped small sticky-header sort-by="descripcionOrden" sort-icon-left :items="ordenesPagoContrib" :fields="fieldsOrdenPago">
                  
                </b-table>
            </b-col>
              
          </b-row>
          
        </b-collapse>
      </b-col>
    </b-row>
    <!-- ---------------------- MOVIMIENTOS --------------------------  -->
    <b-row>
      <b-col class="mt-1">
        <b-button block variant="info" style="text-align:left;" @click="consultarMovimientosContrib(); isVisibleCollapseMovs = !isVisibleCollapseMovs"><b-icon icon="clock-history"/> Histórico de Movimientos</b-button>
        <b-collapse style="width: 100%;" v-model="isVisibleCollapseMovs" accordion="Padrones" role="tabpanel">
          <b-row>
            <b-col>
              <b-card>
                <loading :active.sync="isConsultandoMovimientos" :is-full-page="true"></loading>
                <b-row>
                  <b-col>
                    <b-form-input v-model="filtroMovimientos" type="search"  placeholder="Filtrar por tipo"></b-form-input>
                  </b-col>
                </b-row>
                <b-row v-if="isShowTableMovimientos">
                  <b-col cols="12">
                    <div class="error" v-if="contribuyenteActual.movimientos!=null && contribuyenteActual.movimientos.length == 0">El contribuyente no tiene movimientos.</div>
                    <b-table responsive="xl" striped small sticky-header :items="contribuyenteActual.movimientos" :filter="filtroMovimientos" :filter-included-fields="filtrarOn"></b-table>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <!-- -------------------------- EXPEDIENTE ---------------------------  -->
    <b-row>
      <b-col class="mt-1">
        <b-button block variant="info" style="text-align:left;" @click="consultarExpedientesContrib(); isVisibleCollapseExpediente= !isVisibleCollapseExpediente"><b-icon icon="archive-fill"/> Expediente Digital</b-button>
        <b-collapse  v-model="isVisibleCollapseExpediente" style="width: 100%;" accordion="Padrones" role="tabpanel">
        <b-row>
          <b-col>
            <b-card>
                <loading :active.sync="isConsultandoExpediente" :is-full-page="true"></loading>
                <b-row>
                  <b-col cols="12">
                    <div v-for="expediente in contribuyenteActual.expedientes" :key="expediente.nombre">  
                      <b-button style="text-align:left; margin-top:7px;" block @click="mostrarModalPaginasExpediente(expediente)" variant="secondary">Expediente del día {{expediente.nombre}}</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
          </b-col>
        </b-row>
        </b-collapse>
      </b-col>
    </b-row>

    
    <!-- MODALS -->
    <b-modal title="Ubicación" hide-footer v-model="isShowEditUbicacionDir" header-bg-variant="dark" header-text-variant="light">
      <b-row>
        <b-col cols="12" class="mt-2">
          <b-icon v-if="this.calles=!null && this.calles.length > 0" style="cursor:pointer;" icon="plus-square" @click="isShowModalCalles=true"/> <label>Vialidad:</label>
          <model-select size="sm"  v-if="this.calles=!null && this.calles.length > 0" :state="!$v.contribuyenteActual.ubicacion.vialidad.$invalid" :options="this.calles"  v-model="contribuyenteActual.ubicacion.vialidad"></model-select>
          <b-form-checkbox v-if="this.calles=!null && this.calles.length > 0" v-model="filtrarCallesPorZona">Filtrar por zona</b-form-checkbox>
          <b-form-input size="sm"  v-if="this.calles==null || this.calles.length == 0"  v-model="contribuyenteActual.ubicacion.vialidad"></b-form-input>
        </b-col>
        <b-col cols="6" class="mt-2">No Exterior<b-form-input v-model="contribuyenteActual.ubicacion.noExt"></b-form-input></b-col>
        <b-col cols="6" class="mt-2">No Interior<b-form-input v-model="contribuyenteActual.ubicacion.noInt"></b-form-input></b-col>
        <b-col cols="4" class="mt-2">Manzana<b-form-input v-model="contribuyenteActual.ubicacion.manzana"></b-form-input></b-col>
        <b-col cols="4" class="mt-2">Lote<b-form-input v-model="contribuyenteActual.ubicacion.lote"></b-form-input></b-col>    
        <b-col cols="4" class="mt-2">Código Postal<b-form-input v-model="contribuyenteActual.ubicacion.codigoPostal" ></b-form-input></b-col>    
        <b-col cols="6" class="mt-2">
          <b-icon v-if="this.localidades!=null && this.localidades.length > 0" style="cursor:pointer;" icon="plus-square" @click="isShowModalLocalidad=true"/> <label>Localidad:</label>
          <model-select size="sm"  v-if="this.localidades!=null && this.localidades.length > 0" :state="!$v.contribuyenteActual.ubicacion.localidad.$invalid" :options="this.localidades"  v-model="contribuyenteActual.ubicacion.localidad"></model-select>
          <b-form-input size="sm"  v-if="this.localidades==null || this.localidades.length == 0"  v-model="contribuyenteActual.ubicacion.localidad"></b-form-input>        
        </b-col>
        <b-col cols="6" class="mt-2">
          <b-icon v-if="this.colonias!=null && this.colonias.length > 0" style="cursor:pointer;" icon="plus-square" @click="isShowModalColonia=true"/> <label>Colonia:</label>
          <model-select size="sm"  v-if="this.colonias!=null && this.colonias.length > 0" :state="!$v.contribuyenteActual.ubicacion.colonia.$invalid" :options="this.colonias"  v-model="contribuyenteActual.ubicacion.colonia"></model-select>
          <b-form-input size="sm"  v-if="this.colonias==null || this.colonias.length == 0"  v-model="contribuyenteActual.ubicacion.colonia"></b-form-input>        

        </b-col>
        <b-col cols="6" class="mt-2">Municipio<b-form-input v-model="contribuyenteActual.ubicacion.municipio"></b-form-input></b-col>
        <b-col cols="6" class="mt-2">Estado<b-form-input v-model="contribuyenteActual.ubicacion.estado"></b-form-input></b-col>        
        <b-col cols="6" class="mt-2">Entre Calle<b-form-input v-model="contribuyenteActual.ubicacion.entreCalle" ></b-form-input></b-col>
        <b-col cols="6" class="mt-2">y Calle<b-form-input v-model="contribuyenteActual.ubicacion.yCalle" ></b-form-input></b-col>
        <b-col cols="12" class="mt-2">Denominación del Predio<b-form-input v-model="contribuyenteActual.ubicacion.denominacion" ></b-form-input></b-col>
      </b-row>
      <b-row class="mt-4 mb-4" align="center">
        <b-col cols="12"><b-button pill variant="success" @click="usarUbiDirCompuesta">Continuar <b-icon icon="arrow-right-circle"/></b-button></b-col>
      </b-row>
    </b-modal>

    <b-modal modal-class="base-fiscal-modal" scrollable v-if="idxOfArrayBases != null" title="Base Fiscal" v-model="isShowEditarBases" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
      <div>
        <b-row align="end" v-if="contribuyenteActual.basesFiscales[idxOfArrayBases].gestionCatastral">
          <b-col cols="12"><b-form-checkbox switch v-model="showNuevaVersionValuacion">Nueva interfaz</b-form-checkbox></b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="12" md="12" lg="9" v-if="showNuevaVersionValuacion">
            <panelEditarBaseFiscal  :baseFiscal="contribuyenteActual.basesFiscales[idxOfArrayBases]" :guardarCambiosContrib="guardarCambiosBasesContrib" :isGuardandoDatosContrib="isGuardandoDatosContrib" :contribuyenteActual="contribuyenteActual" />
          </b-col>
          <b-col cols="12" md="12" lg="9" v-if="!showNuevaVersionValuacion">
            <panelEditarBaseFiscalAnt  :baseFiscal="contribuyenteActual.basesFiscales[idxOfArrayBases]" :guardarCambiosContrib="guardarCambiosBasesContrib" :isGuardandoDatosContrib="isGuardandoDatosContrib" :contribuyenteActual="contribuyenteActual" />
          </b-col>
        </b-row>
      </div>  
    </b-modal>

    <b-modal scrollable modal-class="base-fiscal-modal"   title="Base Fiscal" v-model="isShowAgregarManifestacion" size="lg" hide-footer  header-bg-variant="dark" header-text-variant="light">
      <div>
        <b-row align="end">
          <b-col cols="12"><b-form-checkbox switch v-model="showNuevaVersionValuacion">Nueva interfaz</b-form-checkbox></b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="12" md="12" lg="9" v-if="showNuevaVersionValuacion">
            <panelEditarBaseFiscal :baseFiscal="baseFiscalNueva"  :guardarCambiosContrib="agregarNuevaManifestacion" :isGuardandoDatosContrib="isGuardandoDatosContrib" :contribuyenteActual="null" />
          </b-col>
          <b-col cols="12" md="12" lg="9" v-if="!showNuevaVersionValuacion">
            <panelEditarBaseFiscalAnt :baseFiscal="baseFiscalNueva"  :guardarCambiosContrib="agregarNuevaManifestacion" :isGuardandoDatosContrib="isGuardandoDatosContrib" :contribuyenteActual="null" />
          </b-col>
        </b-row>    
      </div>    
    </b-modal>

    <b-modal    title="Tipo de valuación" v-model="isShowCambiarValuacion"  hide-footer  header-bg-variant="dark" header-text-variant="light">
      <b-row align-h="center">
        <b-col cols="12" md="12" lg="12">
          <h6>Año {{valuacionAñoActual}}</h6>
          <b-form-select v-model="nvaValuacionAñoActual" :options="tiposValuacion"></b-form-select>
        </b-col>
        <b-col cols="11" class="mt-4">
          <b-button pill block size="sm" variant="success" @click="actualizaTipoValuacion(valuacionAñoActual, nvaValuacionAñoActual)">Aplicar <b-icon icon="check-circle-fill"/><b-spinner v-if="this.isGuardandoDatosContrib"/> </b-button>
        </b-col>
      </b-row>      
    </b-modal>


    <b-modal v-model="isShowModalEliminaContrib" title="¿Desea eliminar al contribuyente?" hide-footer>
      <b-button variant="success" @click="eliminarContribuyente">Si, Eliminar</b-button>
    </b-modal>

    <b-modal v-model="isShowModalExpediente" size="lg" title="Expediente Digital" hide-footer>
      <b-row align-h="center" align="center" class="mb-2">
        <b-col  cols="2">
          <b-button  size="sm" @click="$refs.carouselexp.prev()" variant="success" pill>Anterior</b-button> 
        </b-col>
        <b-col cols="2">
          <b-button size="sm" @click="$refs.carouselexp.next()" variant="success" pill>Siguiente</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-carousel ref="carouselexp" :interval="10000000"  controls  indicators style="text-shadow: 1px 1px 2px black; color:green;">
            <b-carousel-slide  :img-src="'data:image/jpeg;base64,'+pagina.b64" v-for="pagina in paginasExpedienteActual" :key="pagina.nombre"></b-carousel-slide>
          </b-carousel>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal  v-model="isShowFusionarPredio" title="Fusionar predio" hide-footer size="lg">
      <b-row>
        <b-col><h5>Ingrese los predios a fusionar</h5></b-col>
      </b-row>
      <b-row class="mt-1 mb-1" v-for="(predio,idx) in prediosFusion" :key="idx">
        <b-col><h6>{{predio.clave}}: {{predio.superficies}} <b-icon style="cursor:pointer; color:red;" @click="prediosFusion.splice(idx, 1)" icon="trash"/></h6></b-col>
      </b-row>
      <b-row>
        <b-col><b-input v-model="predioFusionNvo" placeholder="Ingrese una clave del predio a fusionar"></b-input><b-button @click="agregarFusion" size="sm" variant="secondary">Agregar <b-icon icon="plus-circle-fill"/></b-button></b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorFusion != ''">
            {{msgErrorFusion}}
          </b-alert>
        </b-col>
      </b-row>
      <b-row align="center">
        <b-col class="mt-3">
          <b-button variant="danger" @click="fusionarPredios">Fusionar Predios <b-icon icon="grid1x2-fill" v-if="!isFusionando" /> <b-spinner small v-if="isFusionando"/></b-button>
        </b-col>
      </b-row>
    </b-modal>


    <!-- SUBDIVIDIR PREDIO -->
    <b-modal  v-model="isShowSubdividirPredio" title="Subdividir predio" hide-footer size="lg">
      <b-row>
        <b-col><h5>Ingrese los datos del nuevo predio</h5></b-col>
      </b-row>
      <b-row>
        <b-col><b-input v-model="clavePredioNvoSubdividir" placeholder="Ingrese una clave del nuevo predio"></b-input></b-col>
        <b-col><b-input v-model="supPredioNvoSubdividir" placeholder="Superficie"></b-input></b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorSubdividir != ''">
            {{msgErrorSubdividir}}
          </b-alert>
        </b-col>
      </b-row>
      <b-row align="center">
        <b-col class="mt-3">
          <b-button variant="danger" @click="subdividirPredio">Subdividir Predio <b-icon icon="grid1x2-fill" v-if="!isDividiendo" /> <b-spinner small v-if="isDividiendo"/></b-button>
        </b-col>
      </b-row>
    </b-modal>

<!------- RECIBOS DE PAGO --------->
    <b-modal title="Recibo de pago" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalRecibo">
     <b-row>
      <b-col>
        <docs-tramite :isPublico="false" :tokenUser="token" />
      </b-col>
     </b-row>
    </b-modal>

    <b-modal scrollable modal-class="recibo-txt-modal"  title="Recibo de pago" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalReciboTexto" >
     <b-row>
      <b-col>
        <b-form-textarea disabled style="font-family: 'Lucida Console', 'Courier New', 'monospace';" v-model="txtRecActual"  rows="50"></b-form-textarea>
      </b-col>
     </b-row>
    </b-modal>




    <!-- <b-modal v-model="isShowCartografia" title="Cartografía" header-text-variant="light" header-bg-variant="dark" hide-footer>
      <b-row align-h="center" align="center">
        <b-col cols="12">
          <b-img src='@/assets/predio.jpeg' fluid></b-img>
        </b-col>
        <b-col class="mt-5"><b-button @click="isGuardandoDatosContrib=!isGuardandoDatosContrib">Actualizar Valuación Catastral <b-spinner small v-if="isGuardandoDatosContrib"/></b-button></b-col>
      </b-row>

    </b-modal> -->

    <b-modal title="Agregar Nueva Vialidad" v-model="isShowModalCalles" hide-footer>
      <b-row>
        <b-col cols="11" md="3">
          <label>Código</label>
          <b-input v-model="nvoCodCalle" type="number" size="sm" class="mb-2"></b-input>
        </b-col>
        <b-col cols="11" md="9">
          <label>Tipo de vialidad</label>
          <b-form-select v-model="nvoTipoCalle" size="sm" :options="tiposVialidades" class="mb-2"></b-form-select>
        </b-col>
        <b-col cols="11" md="11">
          <label>Nombre</label>
          <b-input v-model="nvaCalle" size="sm" class="mb-2"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button  @click="agregarCalle" size="sm" variant="success">Agregar <b-icon icon="plus-circle"/></b-button>
        </b-col>
      </b-row>
      <b-row class="mt-4" >
        <b-col cols="12" >
          <h5><b-icon icon="list"/>Vialidades Zona {{contribuyenteActual.codZona}}</h5>
        </b-col>        
        <b-col cols="12" v-for="(calle, idx) in calles" :key="idx" style="border-bottom: solid 1px gray;">
          <span>{{calle.text}}</span>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal title="Agregar Nueva Colonia" v-model="isShowModalColonia" hide-footer>
      <b-row>
        <b-col cols="11" md="11">
          <label>Nombre</label>
          <b-input v-model="nvaColonia" size="sm" class="mb-2"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button @click="agregarColonia" size="sm" variant="success">Agregar <b-icon icon="plus-circle" /></b-button>
        </b-col>
      </b-row>
      <b-row class="mt-4" >
        <b-col cols="12" >
          <h5><b-icon icon="list"/>Colonias</h5>
        </b-col>        
        <b-col cols="12" v-for="colonia in catalogoPadrones.colonias" :key="colonia" style="border-bottom: solid 1px gray;">
          <span>{{colonia}}</span>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal title="Agregar Nueva Localidad" v-model="isShowModalLocalidad" hide-footer>
      <b-row>
        <b-col cols="11" md="11">
          <label>Nombre</label>
          <b-form-input v-model="nvaLocalidad" size="sm" class="mb-2"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button  @click="agregarLocalidad" size="sm" variant="success">Agregar <b-icon icon="plus-circle"/></b-button>
        </b-col>
      </b-row>
      <b-row class="mt-4" >
        <b-col cols="12" >
          <h5><b-icon icon="list"/>Localidades</h5>
        </b-col>        
        <b-col cols="12" v-for="localidad in catalogoPadrones.localidades" :key="localidad" style="border-bottom: solid 1px gray;">
          <span>{{localidad}}</span>
        </b-col>
      </b-row>
    </b-modal>

  <!-- Modal para actualizar datos en campaña de actualizacion -->
  <b-modal :title="contribuyenteActual.clave" v-model="showActualizacionDatos" header-bg-variant="dark" header-text-variant="light" hide-footer>
    <b-row align-h="center" align="center">
      <b-col cols="12" class="mt-4 mb-2">
        <h5>...::: Ubicación :::...</h5>
        <b-form-textarea size="lg" placeholder="Ubicación:" type="text" :state="$v.contribuyenteActual.ubicacion.descripcion.$invalid?false:null" v-model="contribuyenteActual.ubicacion.descripcion"></b-form-textarea> 
        
      </b-col>

      <b-col cols="12" class="mt-2">
          <b-icon style="cursor:pointer;" icon="plus-square" @click="isShowModalColonia=true"/> <label>Colonia:</label>
          <model-select size="lg" :state="!$v.contribuyenteActual.ubicacion.colonia.$invalid" :options="this.colonias"  v-model="contribuyenteActual.ubicacion.colonia"></model-select>
      </b-col>
      
      <b-col cols="10">
        <b-button variant="danger" block size="lg" @click="guardarCambiosUbicacionContrib()">Guardar ubicación <b-spinner v-if="isGuardandoDatosContrib"></b-spinner></b-button>
      </b-col>

      <b-col  cols="12" class="col-form-avaluo mt-5" v-if="catalogoPadrones.zonas!= null && catalogoPadrones.zonas.length>0">
        <h5>...::: Valuación :::...</h5>
        <b-form-select size="sm" :options="catalogoPadrones.zonas" v-model="baseFiscalActual.zonaVal"></b-form-select>
        <h6>Terreno M2: {{baseFiscalActual.superficieTerrenoPropio}} </h6>
        <h6>Construcción M2: {{baseFiscalActual.superficieConstruccionPropia}} </h6>
        <h6>Valor Catastral: {{baseFiscalActual.valorCatastral}}</h6>
        <h6>Importe: {{baseFiscalActual.importe}}</h6>
      </b-col>

      <b-col class="mt-2" cols="10">
        <b-button variant="danger" block size="lg" @click="guardarCambiosBasesContrib()">Actualizar valor <b-spinner v-if="isGuardandoDatosContrib"></b-spinner></b-button>
      </b-col>

    </b-row>
    <b-row>

    </b-row>
  </b-modal>

  <b-modal hide-footer title="Coordenada UTM" header-bg-variant="dark" header-text-variant="light" v-model="verModalUTMToLatLng">    
      <b-form @submit.prevent="usarCoordenadaUTM">
        <b-form-group label="Zona UTM:" label-for="zona">
          <b-form-input     disabled       id="zona"            type="number"            v-model.number="zona"            required          ></b-form-input>
        </b-form-group>
        <b-form-group label="Este (X):" label-for="este">
          <b-form-input            id="este"            type="number"            v-model.number="este"            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Norte (Y):" label-for="norte">
          <b-form-input            id="norte"            type="number"            v-model.number="norte"            required          ></b-form-input>
        </b-form-group>
        <b-button variant="success" @click="usarCoordenadaUTM">
          Usar coordenada UTM
        </b-button>
      </b-form>
  </b-modal>


  </b-container>
</template>

<script>
  import { mapState} from 'vuex';
  import axios from 'axios';
  import { minLength, maxLength, required } from 'vuelidate/lib/validators';
  import { server, checkAuth, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
  import {convertUTMToLatLon} from '@/vue-tools'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import panelEditarBaseFiscal from '@/components/padrones/panelEditarBaseFiscal.vue';
  import panelEditarBaseFiscalAnt from '@/components/padrones/panelEditarBaseFiscalAnt.vue';
  import formContribuyente from '@/components/padrones/formContribuyente.vue';
  import PanelAgua from './panelAgua.vue';
  import DocsTramite from '../cobro/DocsTramite.vue';
  import { ModelSelect } from 'vue-search-select'

  export default {
    props: ['clave', 'tipoPadron'],
    computed: {
      ...mapState({
        contribuyenteActual: state=> state.padrones.contribuyenteActual,
        optionsSelectTipo: state=> state.padrones.optionsSelectTipo,
        modelSelectTipo: state=> state.padrones.modelSelectTipo,
        catalogoPadrones: state=> state.padrones.catalogoPadrones,
        token: state => state.login.token,
        msgErrorFusion: state => state.padrones.msgErrorFusion,
        msgErrorSubdividir: state => state.padrones.msgErrorSubdividir
      }),
      ubicToEmbedCoor: {
        get: function(){
          if(this.contribuyenteActual != undefined){
            return this.contribuyenteActual.coordenada.lat + ", " + this.contribuyenteActual.coordenada.lng;
          }else{return null}
        }
      },
      ubicToEmbedUbic: {
        get: function(){
          if(this.contribuyenteActual != undefined){
            var replace = this.contribuyenteActual.ubicacion.descripcion.replace(/ /gi, function () {
                return "%20";
            });
            return replace;
          }else{return null}
        }
      },
      fieldsTablePagos:function(){
        var fieldsSimple = [
              {key: 'concepto', label: 'Concepto'},
              {key: 'folio', label: 'Recibo'},
              {key: 'fecha', label: 'Fecha'},                          
              {key: 'periodo', label: 'Periodo'},
              {key: 'total', label: 'Total'},
              {key: 'tipo', label: 'Tipo'},
              {key:'show_details', label:''}
            ];
         
        var fieldsDetail = [
              {key: 'concepto', label: 'Concepto'},
              {key: 'folio', label: 'Recibo'},
              {key: 'fecha', label: 'Fecha'},   
              {key: 'periodo', label: 'Periodo'},                       
              {key: 'importe', label: 'Importe'},
              {key: 'actualizacion', label: 'Act'},
              {key: 'recargo', label: 'Recargo'},
              {key: 'multa', label: 'Multa'},
              {key: 'gastosEjec', label: 'Gastos'},
              {key: 'iva', label: 'IVA'},
              {key: 'subImp', label: 'Subsidio Importe'},
              {key: 'subRec', label: 'Subsidio Recargo'},
              {key: 'subMul', label: 'Subsidio Multa'},
              {key: 'subGto', label: 'Subsidio Gastos'},
              {key: 'total', label: 'Total'},
              {key: 'usuario', label: 'Usuario'},
              {key:'show_details', label:''}
            ];
        return this.isShowDetallePago ?
             fieldsDetail : fieldsSimple;


      },
      optionsTipoLicencia:function(){
        if(this.contribuyenteActual.tipoContribuyente == '2'){
          //bebidas
          return this.catalogoPadrones.tiposLicenciaBebida;
        }else if(this.contribuyenteActual.tipoContribuyente == '4'){
          //juegos
          return this.catalogoPadrones.tiposLicenciaJuegosEspectaculos;
        }else if(this.contribuyenteActual.tipoContribuyente == '5'){
          //anuncios
          return this.catalogoPadrones.tiposLicenciaAnuncios;
        }else if(this.contribuyenteActual.tipoContribuyente == '6'){
          //comercio
          return this.catalogoPadrones.tiposLicenciaComercio;
        }else if(this.contribuyenteActual.tipoContribuyente == '7'){
          //estacionamiento
          return this.catalogoPadrones.tiposLicenciaEstacionamiento;
        }else if(this.contribuyenteActual.tipoContribuyente == '8'){
          //panteon
          return this.catalogoPadrones.tiposLicenciaPanteones;
        }else{
          return [];
        }
      },
      calles : function(){
        var cs = [];
        for(var idx=0; idx < this.catalogoPadrones.calles.length; idx++){
          if(this.filtrarCallesPorZona ){
            if(this.catalogoPadrones.calles[idx].codZona == this.contribuyenteActual.codZona){
              cs.push({value:this.catalogoPadrones.calles[idx].descripcion, text:this.catalogoPadrones.calles[idx].descripcion});
            }
          }else{
            cs.push({value:this.catalogoPadrones.calles[idx].descripcion, text:this.catalogoPadrones.calles[idx].descripcion});
          }
        }
        return cs;
      },
      colonias : function(){
        var cs = [];
        for(var idx=0; idx < this.catalogoPadrones.colonias.length; idx++){
            cs.push({value:this.catalogoPadrones.colonias[idx], text:this.catalogoPadrones.colonias[idx]});
        }
        return cs;
      },
      localidades : function(){
        var cs = [];
        for(var idx=0; idx < this.catalogoPadrones.localidades.length; idx++){
            cs.push({value:this.catalogoPadrones.localidades[idx], text:this.catalogoPadrones.localidades[idx]});
        }
        return cs;
      },
      baseFiscalActual : function(){
        return this.contribuyenteActual.basesFiscales[0]
        
      },
    },
    components:{
      Loading,
      panelEditarBaseFiscal,
      panelEditarBaseFiscalAnt,
      formContribuyente,
      PanelAgua,
      DocsTramite,
      ModelSelect
    },
    data() {
      return {
        codeClient:this.$route.params.municipio,

        showNuevaVersionValuacion :true,

        showActualizacionDatos:false,

        fieldsTableBasesFiscales:[
                          {key: 'año', label: 'Año'},
                          {key: 'valorCatastral', label: 'Valor Catastral', tdClass: 'text-right', thClass: 'text-right'},
                          {key: 'superficieTerrenoPropio', label: 'Sup Terreno', tdClass: 'text-right', thClass: 'text-right'},
                          {key: 'superficieConstruccionPropia', label: 'Sup Construcción', tdClass: 'text-right', thClass: 'text-right'},
                          {key: 'tipoPredio', label: 'Tipo de Predio',tdClass: 'text-center', thClass: 'text-center'},
                          {key: 'valuacion', label: 'Valuación',tdClass: 'text-center', thClass: 'text-center'},
                          {key: 'acciones', label: 'Acciones',tdClass: 'text-center', thClass: 'text-center'},
                        ],
        fieldsCredito : [
              {key: 'folio', label: 'Recibo'},
              {key: 'fecha', label: 'Fecha'}, 
              {key: 'importe', label: 'Total Adeudo'},
              {key: 'subRec', label: 'Credito usado'},
              {key: 'subImp', label: 'Dinero recibido'},
              {key: 'recargo', label: 'Credito a favor'},
                                        
              
              {key:'show_details', label:''}
            ],

        fieldsExento : [
              {key: 'concepto', label: 'Concepto'},
              //{key: 'fecha', label: 'Fecha'},   
              {key: 'periodo', label: 'Periodo'},                       
              //{key: 'usuario', label: 'Usuario'},
              {key: 'id', label: 'Cancelar'},
              {key:'show_details', label:''}
            ],

        fieldsOrdenPago:[
                    {key:"folioOrden", label:"Orden Pago"},
                    {key:"folioRecibo", label:"Recibo"},
                    {key:"descripcionOrden", label:"Descripción", sortable: true },
                    {key:"fechaVOrden", label:"Vence"},
                    {key:"total", label:"Total"},                   
                ],
        ordenesPagoContrib:[],
         
        isShowDetallePago:false,
        isGuardandoDatosContrib:false,
        isEliminandoContrib:false,
        isConsultandoPago:false,
        isConsultandoMovimientos:false,
        isFusionando : false,
        isDividiendo : false,
        isShowEditUbicacionDir:false,
        isShowModalEliminaContrib:false,
        isShowModalRecibo:false,
        isShowModalReciboTexto:false,
        txtRecActual:'',
        isConsultandoExpediente:false,
        isConsultandoUbicacion:false,
        isShowAgregarManifestacion:false,
        isVisibleCollapseAdeudo:false,
        isShowTablePagos: false,
        isShowTableMovimientos: false,
        isVisibleCollapsePagos:false,
        isVisibleCollapseFormatos:false,
        isVisibleCollapseMovs:false,
        isVisibleCollapseExpediente:false,
        isShowEditarBases:false,
        isShowFusionarPredio:false,
        isShowSubdividirPredio:false,
        isShowCartografia:false,
        idxOfArrayBases:null,
        srcToEmbed: "https://maps.google.com/maps?q=",
        paramsToEmbed: "&t=k&z=18&ie=UTF8&iwloc=&output=embed",
        paginasExpedienteActual:null,
        isShowModalExpediente:false,
        baseFiscalNueva:{
          
          año:1900,
          valorCatastral:0,
          importe:0,
          superficieConstruccionCommun:0,
          superficieConstruccionPropia:0,
          superficieTerrenoComun:0,
          superficieTerrenoPropio:0,
          areaAprovechamiento:0,
          areaInscrita:0,
          valorConstruccionCommun:0,
          valorConstruccionPropia:0,
          valorTerrenoCommun:0,
          valorTerrenoPropio:0,
          numExt:"",
          numInt:"",
          codPostal:"",
          entCalle:"",
          yCalle:"",
          factorFrente:0,
          factorFondo:0,
          factorIrregularidad:0,
          factorArea:0,
          factorTopografico:0,
          factorUbicacion:0,
          factorRestriccion:0,
          frente:0,
          fondo:0,
          desnivel:0,
          pjeCondominio:0,
          gestionCatastral:false,
          codZona:0,
          tipoUsoGral:''
        },
        
        prediosFusion:[],
        predioFusionNvo:"",

        clavePredioNvoSubdividir:"",
        supPredioNvoSubdividir:"",

        pdfGeneratedRecibo:"",
        urlRecFactura:"",
        folioDoc1:"",
        folioDoc2:"",

        isShowModalCalles:false,
        isShowModalColonia:false,
        isShowModalLocalidad:false,
        nvaColonia:"",
        nvaLocalidad:"",
        nvaCalle:"",
        nvoCodCalle:"",
        nvoTipoCalle:"A",
        tiposVialidades:[
          {value:'A', text:'ANDADOR'},
          {value:"B", text:"AVENIDA"},
          {value:"C", text:"BOULEVARD"},
          {value:"D", text:"CALLE"},
          {value:"E", text:"CALLEJON"},
          {value:"F", text:"JARDIN"},
          {value:"G", text:"PASEO"},
          {value:"H", text:"PLAZA"},
          {value:"I", text:"PRIVADA"},
          {value:"J", text:"CALZADA"},
          {value:"K", text:"PASAJE"},
          {value:"L", text:"AUTOPISTA"},
          {value:"M", text:"CAMINO"},
          {value:"N", text:"CARRETERA"},
          {value:"O", text:"FERROCARRIL"},
          {value:"P", text:"SUPERCARRETERA"},
          {value:"Q", text:"VEREDA"},
          {value:"R", text:"CIRCUITO"},
          {value:"S", text:"CERRADA"},
          {value:"T", text:"LIBRAMIENTO"},
          {value:"Z", text:"LIMITE FISICO"}
        ],

        verInfoAdicionalLicencia:false,

        filtroMovimientos:'',
        filtrarOn:['tipo'],


        isShowCambiarValuacion : false,
        valuacionAñoActual:0,
        nvaValuacionAñoActual:"",
        tiposValuacion :[
          {text:"CATASTRADO CON VALUACIÓN AUTOMÁTICA",    value:"AUTOMÁTICA C"},
          {text:"CATASTRADO CON VALUACIÓN MANUAL",        value:"MANUAL C"},
          {text:"NO CATASTRADO CON VALUACIÓN AUTOMÁTICA", value:"AUTOMÁTICA NC"},
          {text:"NO CATASTRADO CON VALUACIÓN MANUAL",     value:"MANUAL NC"},
        ],

        verModalUTMToLatLng : false,
        zona: 14,
        este: null,
        norte: null,

        filtrarCallesPorZona : true

      }
    },
    methods: {
      showModalEditarTipoValuacion(idxOfTableBases){
        this.valuacionAñoActual = this.contribuyenteActual.basesFiscales[idxOfTableBases].año;
        this.nvaValuacionAñoActual = this.contribuyenteActual.basesFiscales[idxOfTableBases].valuacion;
        this.isShowCambiarValuacion = true;
      },
      showModalEditarBases(idxOfTableBases){
        this.idxOfArrayBases = idxOfTableBases;
        this.isShowEditarBases = true;
      },
      eliminarContribuyente(){
        this.isShowModalEliminaContrib=false;
        var datosContribuyente = {
          clave: this.contribuyenteActual.clave, 
          idContrib: this.contribuyenteActual.idContrib, 
          tipoContribuyente: this.contribuyenteActual.tipoContribuyente,  
          fundamento: this.contribuyenteActual.fundamento
        };
             
        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isEliminandoContrib=true;
          axios(
            getPostConfig(server.eliminaContribuyente, datosContribuyente, this.token, {})
            
            ).then(() => {
              this.$store.commit("updateContribuyenteActual", null);
              this.isEliminandoContrib=false;
              alert("Se ha eliminado al contribuyente contribuyente.");
            }).catch(err => {
              this.isEliminandoContrib=false;
              handledError(err, server.eliminaContribuyente, this.$router, this.$store);
            })
        }
      },
      guardarCambiosContrib(){
        var datosContribuyente = {clave: this.contribuyenteActual.clave, clave2: this.contribuyenteActual.clave2,  clave3: this.contribuyenteActual.clave3,
                                  correo: this.contribuyenteActual.correo, curp: this.contribuyenteActual.curp, direccion: this.contribuyenteActual.direccion, 
                                  idContrib: this.contribuyenteActual.idContrib, isBloquearCobro: this.contribuyenteActual.isBloquearCobro, isNotificado: this.contribuyenteActual.isNotificado, 
                                  noActos: this.contribuyenteActual.noActos, apellidoP: this.contribuyenteActual.apellidoP, apellidoM: this.contribuyenteActual.apellidoM, nombre: this.contribuyenteActual.nombre,
                                  obs: this.contribuyenteActual.obs, rfc: this.contribuyenteActual.rfc, 
                                  telefono: this.contribuyenteActual.telefono, tipoContribuyente: this.contribuyenteActual.tipoContribuyente, ubicacion: this.contribuyenteActual.ubicacion, 
                                  coordenada: this.contribuyenteActual.coordenada, tipoPersona:this.contribuyenteActual.tipoPersona, tipoRegimenFiscal:this.contribuyenteActual.tipoRegimenFiscal,
                                  basesFiscales: this.contribuyenteActual.basesFiscales, fundamento: this.contribuyenteActual.fundamento};
                                  

        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editarContribuyente, datosContribuyente, this.token, {tipoPadron:this.contribuyenteActual.tipoContribuyente.substr(0, 1), clave:this.contribuyenteActual.clave})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editarContribuyente, this.$router, this.$store);
            })
        }
      },
      guardarCambiosBasesContrib(añoFuenteBaseFiscal, up, down){
        var datosContribuyente = {clave: this.contribuyenteActual.clave, clave2: this.contribuyenteActual.clave2,  clave3: this.contribuyenteActual.clave3,
                                  correo: this.contribuyenteActual.correo, curp: this.contribuyenteActual.curp, direccion: this.contribuyenteActual.direccion, 
                                  idContrib: this.contribuyenteActual.idContrib, isBloquearCobro: this.contribuyenteActual.isBloquearCobro, isNotificado: this.contribuyenteActual.isNotificado, 
                                  noActos: this.contribuyenteActual.noActos, nombre: this.contribuyenteActual.nombre, apellidoP: this.contribuyenteActual.apellidoP, apellidoM: this.contribuyenteActual.apellidoM,
                                  obs: this.contribuyenteActual.obs, rfc: this.contribuyenteActual.rfc, 
                                  telefono: this.contribuyenteActual.telefono, tipoContribuyente: this.contribuyenteActual.tipoContribuyente, ubicacion: this.contribuyenteActual.ubicacion, 
                                  coordenada: this.contribuyenteActual.coordenada, tipoPersona:this.contribuyenteActual.tipoPersona, tipoRegimenFiscal:this.contribuyenteActual.tipoRegimenFiscal,
                                  basesFiscales: this.contribuyenteActual.basesFiscales, fundamento: this.contribuyenteActual.fundamento};
                                  

        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editarBasesContribuyente, datosContribuyente, this.token, {añoUnificado:añoFuenteBaseFiscal, up:up, down:down, tipoPadron:this.contribuyenteActual.tipoContribuyente.substr(0, 1), clave:this.contribuyenteActual.clave})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editarContribuyente, this.$router, this.$store);
            })
        }
      },
      guardarCambiosUbicacionContrib(){
        var datosContribuyente = {clave: this.contribuyenteActual.clave, clave2: this.contribuyenteActual.clave2,  clave3: this.contribuyenteActual.clave3,
                                  correo: this.contribuyenteActual.correo, curp: this.contribuyenteActual.curp, direccion: this.contribuyenteActual.direccion, 
                                  idContrib: this.contribuyenteActual.idContrib, isBloquearCobro: this.contribuyenteActual.isBloquearCobro, isNotificado: this.contribuyenteActual.isNotificado, 
                                  noActos: this.contribuyenteActual.noActos, nombre: this.contribuyenteActual.nombre, apellidoP: this.contribuyenteActual.apellidoP, apellidoM: this.contribuyenteActual.apellidoM, 
                                  obs: this.contribuyenteActual.obs, rfc: this.contribuyenteActual.rfc, 
                                  telefono: this.contribuyenteActual.telefono, tipoContribuyente: this.contribuyenteActual.tipoContribuyente, ubicacion: this.contribuyenteActual.ubicacion, 
                                  coordenada: this.contribuyenteActual.coordenada, tipoPersona:this.contribuyenteActual.tipoPersona, tipoRegimenFiscal:this.contribuyenteActual.tipoRegimenFiscal,
                                  basesFiscales: this.contribuyenteActual.basesFiscales, fundamento: this.contribuyenteActual.fundamento};
                                  

        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editarUbicacionContribuyente, datosContribuyente, this.token, {tipoPadron:this.contribuyenteActual.tipoContribuyente.substr(0, 1), clave:this.contribuyenteActual.clave})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editarContribuyente, this.$router, this.$store);
            })
        }
      },
      actualizaTipoValuacion(año, tipo){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.cambiatipovaluacion, {}, this.token, { clave:this.contribuyenteActual.clave, año:año, tipo:tipo})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              this.isShowCambiarValuacion=false;
              alert("Se ha actualizado la información de la valuación.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              this.isShowCambiarValuacion=false;
              handledError(err, server.cambiatipovaluacion, this.$router, this.$store);
            })
        }
      },
      showAgregarManifestacion(){
        this.isShowAgregarManifestacion=true
        this.baseFiscalNueva.gestionCatastral = this.contribuyenteActual.basesFiscales[0].gestionCatastral;
        this.baseFiscalNueva.codZona = this.contribuyenteActual.basesFiscales[0].codZona;
        this.baseFiscalNueva.tipoUsoGral = this.contribuyenteActual.basesFiscales[0].tipoUsoGral;
        this.baseFiscalNueva.regimenPropiedad = 'SIN DESCRIPCION';
      },
      agregarNuevaManifestacion(){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.altamanifestacion, this.baseFiscalNueva, this.token, { clave:this.contribuyenteActual.clave})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              this.isShowAgregarManifestacion=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              this.isShowAgregarManifestacion=false;
              handledError(err, server.altamanifestacion, this.$router, this.$store);
            })
        }
      },
      consultarPagosContrib(){
        if(!this.isConsultandoPago && !this.isVisibleCollapsePagos && checkAuth(this.$router, this.$store)){
          this.isConsultandoPago=true;
          axios(
            getGetConfig(server.pagosContribuyente, null, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updatePagosContribuyenteActual", res.data[0]);
              this.ordenesPagoContrib = res.data[1];
              this.isShowTablePagos = true;
              this.isConsultandoPago=false;
            }).catch(err => {
                this.isConsultandoPago=false;
                handledError(err, server.pagosContribuyente, this.$router, this.$store);
            })
        }
      },
      actualizaPagosContrib(){
        if(!this.isConsultandoPago && checkAuth(this.$router, this.$store)){
          this.isConsultandoPago=true;
          axios(
            //se actualizan pagos
            getGetConfig(server.ultrecibo, null, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(() => {
             
              this.isShowTablePagos = true;
              this.isConsultandoPago=false;
              //se vuelven a consultar
              this.consultarPagosContrib();

            }).catch(err => {
                this.isConsultandoPago=false;
                handledError(err, server.pagosContribuyente, this.$router, this.$store);
            })
        }
      },
      consultaRecibo(folio){
        if(!this.isConsultandoPago  && checkAuth(this.$router, this.$store)){
          this.isConsultandoPago=true;
          axios(
              getGetConfig(server.recibo, null, this.token, {serieFolio:folio})
          )
          .then(res => {
            if(res.data.includes('texto_certificado|')){
              this.txtRecActual = res.data.split('|')[1];
              this.isShowModalReciboTexto = true;
              
            }else{
              this.$store.commit("updatePdfsGenerated", res.data);
              this.isShowModalRecibo = true;

            }
            this.isConsultandoPago=false
            
          }).catch(err => {
              this.isConsultandoPago = false;
              handledError(err, server.recibo, this.$router, this.$store);
          });
        }
      },
      consultarMovimientosContrib(){
        if(!this.isConsultandoMovimientos && !this.isVisibleCollapseMovs && checkAuth(this.$router, this.$store)){
          this.isConsultandoMovimientos=true;
          axios(
            getGetConfig(server.movsContribuyente, null, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updateMovimientosContribuyenteActual", res.data);
              this.isShowTableMovimientos = true;
              this.isConsultandoMovimientos=false;
            }).catch(err => {
                this.isConsultandoMovimientos=false;
                handledError(err, server.movsContribuyente, this.$router, this.$store);
            })
        }
      },
      consultarExpedientesContrib(){
        if(!this.isConsultandoExpediente && checkAuth(this.$router, this.$store) && !this.isVisibleCollapseExpediente){
          this.isConsultandoExpediente=true;
          axios(
            getGetConfig(server.expedientesContribuyente, {}, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updateExpedientesContribuyenteActual", res.data);
              this.isConsultandoExpediente=false;
          }).catch(err => {
              this.isConsultandoExpediente=false;
              handledError(err, server.expedientesContribuyente, this.$router, this.$store);
          })
        }
      },
      mostrarModalPaginasExpediente(expediente){
        this.paginasExpedienteActual = expediente.paginas;
        this.isShowModalExpediente = true;
      },
      consultarUbicacionContrib(){
        if(!this.isConsultandoUbicacion && checkAuth(this.$router, this.$store)){
          this.isConsultandoUbicacion=true;
          axios(
            getPostConfig(server.ubicacionContribuyente, {}, this.token)
            ).then(res => {
              alert(res);
              //this.$store.commit("updateContribuyentes", res);
              this.isConsultandoUbicacion=false;
          }).catch(err => {
              this.isConsultandoUbicacion=false;
              handledError(err, server.ubicacionContribuyente, this.$router, this.$store);
          })
        }
      },
      agregarFusion(){
        if(this.predioFusionNvo != null && this.predioFusionNvo.trim()!='' && !this.isFusionando && checkAuth(this.$router, this.$store)){
          this.isFusionando = true;
          axios(
            getGetConfig(server.validarclavecat, {}, this.token, {clave:this.predioFusionNvo})
            ).then(res => {
              this.isFusionando=false;
              this.prediosFusion.push(res.data)
              this.predioFusionNvo  =''
          }).catch(err => {
              this.isFusionando=false;
              handledError(err, server.validarclavecat, this.$router, this.$store);
          })
          
        }
      },
      cleanMsgError(){
        /* Se manda cadena vacia  en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
        this.$store.commit("updateMsgErrorFusion", '');
        this.$store.commit("updateMsgErrorSubdividir");
      },
      fusionarPredios(){
        if( !this.isFusionando && checkAuth(this.$router, this.$store)){
          this.$store.commit("updateMsgErrorFusion", '');
          this.isFusionando = true;
          axios(
            getPostConfig(server.fusionpredios, {claveFuente: this.contribuyenteActual.clave, claves:this.prediosFusion}, this.token, {})
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isFusionando=false;
              this.isShowFusionarPredio=false;
              this.prediosFusion=[];
              alert("Predios fusionados exitosamente");
          }).catch(err => {
              this.isFusionando=false;
              handledError(err, server.fusionpredios, this.$router, this.$store);
          })
          
        }
        
      },
      subdividirPredio(){
        if( !this.isDividiendo && checkAuth(this.$router, this.$store)){
          this.$store.commit("updateMsgErrorSubdividir", '');
          this.isDividiendo = true;
           axios(
             getPostConfig(server.subdivisionpredio, {claveFuente: this.contribuyenteActual.clave, claveNueva:this.clavePredioNvoSubdividir, superficie:this.supPredioNvoSubdividir}, this.token, {})
             ).then(res => {
               this.$store.commit("updateContribuyenteActual", res.data);
               this.isDividiendo=false;
               this.isShowSubdividirPredio=false;
               
               alert("Nuevo registro generado!");
           }).catch(err => {
               this.isDividiendo=false;
               this.isShowSubdividirPredio=false;
               handledError(err, server.subdivisionpredio, this.$router, this.$store);
           })
          
        }
      },
      
      agregarCalle(){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.agregacalle, {codZona:this.contribuyenteActual.codZona ,nombre:this.nvaCalle, codigo:this.nvoCodCalle, tipo:this.nvoTipoCalle}, this.token, null)            
            ).then(res => {
              this.isGuardandoDatosContrib=false;
              this.isShowModalCalles = false;
              alert('La calle se dio de alta exitosamente');
              this.catalogoPadrones.calles.push(res.data);
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.agregacalle, this.$router, this.$store);
            })
            this.nvaCalle=""
            this.nvoCodCalle=""
        }
      },
      agregarColonia(){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.agregacolonia, {codZona:'' ,nombre:this.nvaColonia, codigo:'', tipo:''}, this.token, null)            
            ).then(() => {
              this.isGuardandoDatosContrib=false;
              this.isShowModalColonia = false;
              alert('La colonia se dio de alta exitosamente');
              this.$store.commit("updateColoniaCatalog", this.nvaColonia);
               this.nvaColonia="";
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.agregacolonia, this.$router, this.$store);
            })
           
        }
      },
      agregarLocalidad(){
        if(!this.isGuardandoDatosContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.agregalocalidad, {codZona:'' ,nombre:this.nvaLocalidad, codigo:'', tipo:''}, this.token, null)            
            ).then(() => {
              this.isGuardandoDatosContrib=false;
              this.isShowModalLocalidad = false;
              alert('La localidad se dio de alta exitosamente');
              this.$store.commit("updateLocalidadCatalog", this.nvaLocalidad);
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.agregalocalidad, this.$router, this.$store);
            })
            
        }
      },
      generarDocumento: function(tipoPadron, documento){
        if(!this.isGuardandoDatosContrib & checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          var body={
            idContrib: this.contribuyenteActual.idContrib,
            tipoPadron : tipoPadron,
            doc : documento,
            folio : this.folioDoc1,
            folioPago : this.folioDoc2,
            anexos : this.filesInspeccion
          }
          axios(
            getPostConfig(server.generadoccontrib, body, this.token, {})            
            ).then(res => {
              // pdf b64 begins with JVBER and docx b64 begins with UEsDB
              const mime1 = res.data[0].includes('UEsDB')?'vnd.openxmlformats-officedocument.wordprocessingml.document':'pdf';
              const ext1 = res.data[0].includes('UEsDB')?'.docx':'.pdf';

              var pdf= 'data:application/'+mime1+';base64,'+res.data[0];              
              var downloadPdf = document.createElement('a');
              downloadPdf.setAttribute('href', pdf);
              downloadPdf.setAttribute('download', documento+ext1);
              downloadPdf.click();  

              if(res.data[1] !=null){
                // pdf b64 begins with JVBER and docx b64 begins with UEsDB
                const mime2 = res.data[1].includes('UEsDB')?'vnd.openxmlformats-officedocument.wordprocessingml.document':'pdf';
                const ext2 = res.data[1].includes('UEsDB')?'.docx':'.pdf';
                const pdfAnexo= 'data:application/'+mime2+';base64,'+res.data[1];              
                const downloadPdfAnexo = document.createElement('a');
                downloadPdfAnexo.setAttribute('href', pdfAnexo);
                downloadPdfAnexo.setAttribute('download', documento+"_Anexo"+ext2);
                downloadPdfAnexo.click();  
              }
              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.generadoccontrib, this.$router, this.$store);
            })
        }
      },
      usarUbiDirCompuesta(){
        
        this.contribuyenteActual.ubicacion.descripcion =
        this.contribuyenteActual.ubicacion.vialidad+ " "+
        this.contribuyenteActual.ubicacion.noExt+ " "+
        this.contribuyenteActual.ubicacion.noInt+ " "+
        this.contribuyenteActual.ubicacion.manzana+ " "+
        this.contribuyenteActual.ubicacion.lote+ " "+
        this.contribuyenteActual.ubicacion.localidad+ " "+
        this.contribuyenteActual.ubicacion.colonia+ " "+
        "C.P. "+this.contribuyenteActual.ubicacion.codigoPostal+ " "+
        this.contribuyenteActual.ubicacion.municipio+ " "+
        this.contribuyenteActual.ubicacion.estado+ " ";

        this.contribuyenteActual.ubicacion.descripcion = this.contribuyenteActual.ubicacion.descripcion.replace(/\s+/g, ' ');

        this.isShowEditUbicacionDir = false;
      },
      cancelaExento(idTran){
        axios(
            getGetConfig(server.cancelaExentaPeriodo, null, this.token, {idTran:idTran})            
            ).then(() => {
              this.isVisibleCollapsePagos=false;
              
            }).catch(err => {
              alert(err);
        })
        
      },
      usarCoordenadaUTM() {
        const { zona, este, norte } = this;

        if (!zona || !este || !norte) {
          alert("Por favor llena todos los campos.");
          return;
        }

        const { lat, lon } = convertUTMToLatLon(este, norte, zona);

        this.contribuyenteActual.coordenada.lat = lat.toFixed(6);
        this.contribuyenteActual.coordenada.lng = lon.toFixed(6);

        this.verModalUTMToLatLng = false;
      },
      
    },
    validations: {
      contribuyenteActual:{
        ubicacion:{
          descripcion:{
            required,
            minLength: minLength(1),
            maxLength: maxLength(300)
          },
          vialidad:{},
          noExt:{},
          noInt:{},
          manzana:{},
          lote:{},
          colonia:{},
          localidad:{},
          municipio:{},
          estado:{},
          codigoPostal:{},
          entreCalle:{},
          yCalle:{},
          denominacion:{}     
        }
      }
    }
  }
</script>
<style>
div.error    {color: red;}

.base-fiscal-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}
.recibo-txt-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}
</style>